import { IConfigModalConfirm } from 'interfaces'

export const CONFIRM_MODAL_SETTING: IConfigModalConfirm = {
  messageSuccess: 'exam-finished-success',
  messageError: 'exam-finished-error',
  titleCustom: 'confirm-title-doctor-finished',
  descriptionCustom: 'confirm-without-payment',
  icon: '/images/ic-accept.svg'
}
